import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

import { FinanceFilterEnum } from '@/features/finance/definitions/enums'

import { queryController } from '@composables/queryController'

export const useFinanceQueryStore = defineStore('useFinanceQueryStore', () => {
  const route = useRoute()
  const { getQueryString } = queryController()

  const getInitialState = () => ({
    [FinanceFilterEnum.point_code]: getQueryString(route.query, FinanceFilterEnum.point_code),
    [FinanceFilterEnum.created_date_from]: getQueryString(route.query, FinanceFilterEnum.created_date_from),
    [FinanceFilterEnum.created_date_to]: getQueryString(route.query, FinanceFilterEnum.created_date_to),
    [FinanceFilterEnum.displayed_currency]: getQueryString(route.query, FinanceFilterEnum.displayed_currency)
  })

  const financeState = ref(getInitialState())

  const updateFinanceStateQuery = (vals: Partial<typeof financeState.value>) => {
    financeState.value = Object.assign(financeState.value, vals)
  }

  const clearFinanceState = () => {
    financeState.value = {
      [FinanceFilterEnum.point_code]: '',
      [FinanceFilterEnum.created_date_from]: '',
      [FinanceFilterEnum.created_date_to]: '',
      [FinanceFilterEnum.displayed_currency]: ''
    }
  }

  return {
    financeState,
    updateFinanceStateQuery,
    clearFinanceState
  }
})
